<template>
  <div :id="id + '_matchingtext'" class="visually-hidden" tabindex="-1">
    {{ matchingText }}
  </div>
  <ul
    v-if="listItems && listItems.length"
    class="list"
    v-bind:aria-labelledby="rubrik && rubrik.length > 0 ? id + '_h2' : null"
    v-bind:aria-describedby="
      matchingText.length > 0 ? id + '_matchingtext' : null
    "
    tabindex="-1"
  >
    <ListItem
      v-for="(item, index) in listItems"
      :key="index"
      :listItem="item"
    ></ListItem>
  </ul>
</template>

<script>
import ListItem from "./listitem.vue";

export default {
  name: "List",
  props: {
    id: String,
    rubrik: String,
    listItems: Array,
    totalMatchingText: String,
  },
  components: {
    ListItem,
  },
  data: function () {
    return {
      matchingText: "",
    };
  },
  created() {
    this.matchingText = this.totalMatchingText;
  },
  watch: {
    totalMatchingText: {
      handler: function (val) {
        if (val && val.length > 0) {
          this.matchingText = val;
          document.getElementById(this.id + "_matchingtext").focus();
        } else {
          this.matchingText = "";
        }
      },
      deep: true,
    },
  },
};
</script>
